function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable max-classes-per-file */
import React from 'react';
import RedirectException from './RedirectException';
var Redirect = /*#__PURE__*/function () {
  function Redirect(_ref) {
    var from = _ref.from,
      to = _ref.to,
      status = _ref.status;
    _classCallCheck(this, Redirect);
    this.path = from;
    this.to = to;
    this.status = status;
  }
  return _createClass(Redirect, [{
    key: "render",
    value: function render(_ref2) {
      var match = _ref2.match;
      var to = this.to,
        status = this.status;
      var toLocation;
      if (typeof to === 'function') {
        toLocation = to(match);
      } else {
        var router = match.router,
          params = match.params;
        toLocation = router.matcher.format(to, params);
      }
      throw new RedirectException(toLocation, status);
    }
  }]);
}();
if (process.env.NODE_ENV !== "production") {
  // Workaround to make React Proxy give me the original class, to allow
  // makeRouteConfig to get the actual class, when using JSX for routes.
  Redirect.prototype.isReactComponent = {};
}

// This actually doesn't extend a React.Component, but we need consumer to think that it does

export default Redirect;